var Handlebars = require("handlebars/dist/handlebars.runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\">\r\n    <div class=\"col-xs-12\">\r\n        <div class=\"loading-wave\">\r\n            <span class=\"dot\"></span>\r\n            <span class=\"dot\"></span>\r\n            <span class=\"dot\"></span>\r\n            <span class=\"dot\"></span>\r\n            <span class=\"dot\"></span>\r\n        </div>\r\n    </div>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./shared/templates/loading-dots-row-template.handlebars
// module id = 7
// module chunks = 0